/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GeoCampaignDTO } from './geoCampaignDTO';
import { GeoTestRegionsDataDTO } from './geoTestRegionsDataDTO';
import { GeoTestScheduleDTO } from './geoTestScheduleDTO';


export interface GeoTestSaveRequestDTO { 
    clientId: number;
    brandId: number;
    status: GeoTestSaveRequestDTO.StatusEnum;
    testName: string;
    businessQuestion?: string;
    selectedTacticIds: Array<string>;
    conversionTypeIds: Array<number>;
    conversionTypeNames: Array<string>;
    testRegions: GeoTestRegionsDataDTO;
    campaigns: Array<GeoCampaignDTO>;
    referenceStartDate?: string;
    referenceEndDate?: string;
    testSchedule?: GeoTestScheduleDTO;
    executionMethod?: GeoTestSaveRequestDTO.ExecutionMethodEnum;
    recommendationId?: number;
    vendor?: string;
    scaleCost?: number;
    accountTypes?: Array<string>;
}
export namespace GeoTestSaveRequestDTO {
    export type StatusEnum = 'DRAFT' | 'ACTIVE' | 'INACTIVE';
    export const StatusEnum = {
        Draft: 'DRAFT' as StatusEnum,
        Active: 'ACTIVE' as StatusEnum,
        Inactive: 'INACTIVE' as StatusEnum
    };
    export type ExecutionMethodEnum = 'AUTOMATIC' | 'MANUAL';
    export const ExecutionMethodEnum = {
        Automatic: 'AUTOMATIC' as ExecutionMethodEnum,
        Manual: 'MANUAL' as ExecutionMethodEnum
    };
}


